import { getSquishVinData } from 'client/data/models/vehicle-vin';
import { logger } from 'client/utils/logger/logger';

export async function fetchSquishVinData(squishVin, fields) {
  if (!squishVin || typeof squishVin !== 'string') {
    return null;
  }

  try {
    const apiData = await getSquishVinData(squishVin, null, fields);

    return apiData;
  } catch (error) {
    logger.error(`An error occurred while fetching data for ${squishVin}:`, error);
    return null;
  }
}
